import { render, staticRenderFns } from "./SpecialStock.vue?vue&type=template&id=c033bbea&"
import script from "./SpecialStock.vue?vue&type=script&lang=js&"
export * from "./SpecialStock.vue?vue&type=script&lang=js&"
import style0 from "./SpecialStock.vue?vue&type=style&index=0&id=c033bbea&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports